module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "support"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Support"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Open a support ticket and our teams will help you'),
      expression: "'Open a support ticket and our teams will help you'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (_vm.supportTicketsAvailable === true) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('h4', {
    staticClass: "support-legend-title"
  }, [_vm._v("Department Contact")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 support-ledgend nopad"
  }, [_c('h2', {
    staticClass: "ticket-form"
  }, [_vm._v("Ticket Form")]), _vm._v(" "), _vm._m(2)])]) : (_vm.supportTicketsAvailable === false) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Support opens at 12 PM PT on the Tuesday before your first term begins. Check back then!")])]) : _c('div', [_c('Loader')], 1)]), _vm._v(" "), (_vm.tickets) ? _c('div', {
    staticClass: "tickets"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Old Support Tickets (Discontinued)"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('This ticket system will be discontinued, please create a new ticket above.'),
      expression: "'This ticket system will be discontinued, please create a new ticket above.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.tickets), function(ticket, index) {
    return _c('li', {
      staticClass: "list-group-item ticket-wrapper",
      attrs: {
        "id": 'ticket_' + ticket.id
      }
    }, [_c('div', {
      staticClass: "content ticket-info row clearfix",
      on: {
        "click": function($event) {
          _vm.openTicket(index)
        }
      }
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [(_vm.selectedTicket !== index) ? _c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("stripTags")(ticket.body), 2700)))]) : _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(ticket.body))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h5', [_vm._v("Department: " + _vm._s(_vm._f("capitalize")(ticket.department)))]), _vm._v(" "), (ticket.department === 'course' && ticket.tags.length > 0 && ticket.tags[0]) ? _c('div', {
      staticClass: "indent"
    }, [_vm._v("\n                                    (" + _vm._s(_vm._f("formatCourseTags")(ticket.tags)) + ")\n                                ")]) : _vm._e(), _vm._v(" "), (ticket.agent) ? _c('div', [_c('h5', {
      staticClass: "representative"
    }, [_vm._v("Representative:")]), _vm._v(" "), _c('div', {
      staticClass: "indent"
    }, [_vm._v(_vm._s(ticket.agent.firstName) + " " + _vm._s(ticket.agent.lastName))])]) : _vm._e(), _vm._v(" "), (ticket.resolved) ? _c('div', {
      staticClass: "resolved"
    }, [_vm._v("Resolved")]) : _vm._e()])]), _vm._v(" "), (_vm.selectedTicket === index) ? _c('div', [(ticket.replies.length > 0) ? _c('ul', {
      staticClass: "list-group replies"
    }, _vm._l((ticket.replies), function(reply) {
      return _c('li', {
        staticClass: "list-group-item",
        class: {
          'from-me': _vm.isFromMe(reply.from) === true
        }
      }, [_c('div', {
        staticClass: "reply-body",
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.linkify(reply.body))
        }
      })])
    })) : _vm._e(), _vm._v(" "), _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.replyToTicket(index)
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('vue-html5-editor', {
      attrs: {
        "content": ticket.reply
      },
      on: {
        "change": _vm.updateReply
      }
    })], 1), _vm._v(" "), _vm._m(3, true)])]) : _vm._e()])
  }))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8 support-ledgend nopad"
  }, [_c('p', [_c('strong', [_vm._v("Admissions")]), _c('br'), _vm._v("\n                    For questions about applying for another Think Tank program please email "), _c('a', {
    attrs: {
      "href": "mailto:admissions@tttc.ca"
    }
  }, [_vm._v("admissions@tttc.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Program Management/Academics")]), _c('br'), _vm._v("\n                    For questions about class schedules, curriculum, lessons files, resources, grades or general academic support please email "), _c('a', {
    attrs: {
      "href": "mailto:programmanagement@tttc.ca"
    }
  }, [_vm._v("programmanagement@tttc.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Career Success")]), _c('br'), _vm._v("\n                    For help with your job hunt and other post-graduation support please email "), _c('a', {
    attrs: {
      "href": "mailto:careerdev@tttc.ca"
    }
  }, [_vm._v("careerdev@tttc.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Financial / Tuition / Payments")]), _c('br'), _vm._v("\n                    For any assistance with tuition payments, financial aid etc please email "), _c('a', {
    attrs: {
      "href": "mailto:accounting@tttc.ca"
    }
  }, [_vm._v("accounting@tttc.ca")])]), _vm._v(" "), _c('h4', {
    staticClass: "support-legend-title secondary"
  }, [_vm._v("Technical Support (Software) & Portal Issues")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8 support-ledgend nopad"
  }, [_c('div', {}, [_c('p', [_c('strong', [_vm._v("Computer Support / Software Licensing")]), _c('br'), _vm._v("Problems with installing software? Looking for recommended hardware specs? Something not working in Windows? Create a ticket today!\n                    "), _c('br'), _c('br'), _vm._v("For any software specific questions, \"UVs won't unwrap in Maya\" for example, please post in your group chat channel or message your supervisor.")])]), _vm._v(" "), _c('div', {}, [_c('p', [_c('strong', [_vm._v("Portal Issues")]), _c('br'), _vm._v("\n                        Experiencing a Portal / Chat issue that's hampering your learning experience? Let us know ASAP and create a ticket!\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("* Responses can take 24-36 business hours. Please keep in mind, we adopt normal business hours (9-5 Mon-Fri, Canadian holidays are also observed) and will answer to the best of our abilities within working hours (PST).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-xs-12 nopad",
    attrs: {
      "id": "hubspotForm"
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4456a215!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support.vue
// module id = 2038
// module chunks = 2